import {Typography} from '@mui/material';
import {styled} from '@mui/system';

import zoomPalette from 'zoomPalette';

export const TypographyTitle = styled(Typography)(({theme}) => ({
  fontWeight: 510,
  fontSize: '0.875rem',
  color: zoomPalette.gray['90'],
}));

export const TypographyDesc = styled(Typography)(({theme}) => ({
  color: zoomPalette.gray['60'],
  fontSize: '12px',
  fontWeight: 450,
}));

export const ModalContentContainer = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'left',
}));

export const AccountInfoContainer = styled('div')(({theme}) => ({
  backgroundColor: zoomPalette.gray[10],
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  gap: '8px',
  padding: '8px',
  margin: '8px 0 16px 0',
}));

export const RowNameAndService = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  color: zoomPalette.gray['90'],
  fontWeight: 450,
}));

export const RowEmailAdress = styled(Typography)(({theme}) => ({
  fontSize: '12px',
  color: '#222230',
}));
